import { useRouter } from 'next/router';

/**
 * Check if a given route name matches the current active route.
 * @param routeName - The route name to compare with the active route.
 * @returns 'active' if the route name matches the active route, otherwise an empty string.
 */
export const ActiveRoute = (routeName: string) => {
  const activeRoute = useRouter();
  return routeName === activeRoute.pathname ? 'active' : '';
};

/**
 * Get the current path name of the page.
 * @returns {string} The current path name.
 */
export const GetPathName = () => {
  const route = useRouter();
  const pathName = route.asPath;
  return pathName;
};

// export const CapitalizeFirstLetter = (word: string) => {
//   return word.toLowerCase().replace(/(?:^|\s|-)\S/g, firstLetter => {
//     return firstLetter.toUpperCase();
//   });
// };
